import * as ko from "knockout";
import { Comment } from "./Comment"
import { DateHelper } from "./DateHelper"
import { UrlHelper } from "./UrlHelper"
import TalkAboutSummernoteFactory, { SummerNoteConfig } from "../talkabout-summernote-factory";

declare global {
    interface Window { thisPage: any; __localeId__: String; }
}

declare var modalManager;
declare var windowHelper;
declare var captchaHelper;
//declare var grecaptcha;

//https://meta.stackoverflow.com/questions/299630/stack-overflow-modifications-to-pagedown
//https://bootsnipp.com/snippets/M5obX


export class TalkAboutHtml {

    threadElement: HTMLDivElement;
    threadElementId: string;
    projectId: string;
    threadId: string;
    threadUrl: string;
    threadTitle: string;
    threadPubDate: string; //don't need real date since we are just passing this to the server
    dataUrl: string;
    xsrfTokenName: string;
    xsrfToken: string;

    currentPage: ko.KnockoutObservable<number> = ko.observable(1);
    pageSize: ko.KnockoutObservable<number> = ko.observable(50);
    totalItems: ko.KnockoutObservable<number> = ko.observable(0); //this is root level items
    maxDepth: ko.KnockoutObservable<number> = ko.observable(3)

    requireName: ko.KnockoutObservable<boolean> = ko.observable(false);
    requireEmail: ko.KnockoutObservable<boolean> = ko.observable(false);
    allowPost: ko.KnockoutObservable<boolean> = ko.observable(false);

    allowImageUpload: ko.KnockoutObservable<boolean> = ko.observable(false);
    imageUploadUrl: ko.KnockoutObservable<string> = ko.observable(null);
    allowImageBrowse: ko.KnockoutObservable<boolean> = ko.observable(false);

    allowWebsiteUrl: ko.KnockoutObservable<boolean> = ko.observable(false);
    requireCaptcha: ko.KnockoutObservable<boolean> = ko.observable(false);
    recaptchaPublicKey: ko.KnockoutObservable<string> = ko.observable(null);
    useInvisibleCaptcha: ko.KnockoutObservable<boolean> = ko.observable(true);
    isModerator: ko.KnockoutObservable<boolean> = ko.observable(false);
    moderateAnonymousPosts: ko.KnockoutObservable<boolean> = ko.observable(false);
    moderateAuthenticatedPosts: ko.KnockoutObservable<boolean> = ko.observable(false);
    allowDeleteModeratedPosts: ko.KnockoutObservable<boolean> = ko.observable(true);
    isAuthenticated: ko.KnockoutObservable<boolean> = ko.observable(false);
    hasUserUrl: ko.KnockoutObservable<boolean> = ko.observable(false);
    comments: ko.KnockoutObservableArray<Comment> = ko.observableArray();
    reportReasons: ko.KnockoutObservableArray<any> = ko.observableArray();
    reportReason: ko.KnockoutObservable<string> = ko.observable(null);
    reportText: ko.KnockoutObservable<string> = ko.observable(null);
    reportSendEmailCopy: ko.KnockoutObservable<boolean> = ko.observable(false);
    reportedByCurrentUser: ko.KnockoutObservableArray<string> = ko.observableArray();
    currentReportCommentId: ko.KnockoutObservable<string> = ko.observable(null);

    // Load More Comments functionality
    initialCommentCount: ko.KnockoutObservable<number> = ko.observable(10);
    visibleCommentCount: ko.KnockoutObservable<number> = ko.observable(10);
    visibleComments: ko.Computed<Comment[]>;
    hasMoreComments: ko.Computed<boolean>;
    handleLoadMoreComments: any;

    userId: ko.KnockoutObservable<string> = ko.observable(null)
    userName: ko.KnockoutObservable<string> = ko.observable(null).extend({ required: "Username is required" });
    userEmail: ko.KnockoutObservable<string> = ko.observable(null).extend({ required: "Email is required" });
    userAvatarUrl: ko.KnockoutObservable<string> = ko.observable("https://www.gravatar.com/avatar/205e460b479e2e5b48aec07710c08d50?f=y&s=80&d=mp");
    userWebsite: ko.KnockoutObservable<string> = ko.observable(null);

    newCommentHtml: ko.KnockoutObservable<string> = ko.observable(null).extend({ required: "You must provide a comment" }).extend({ notify: 'always' });

    loginUrl: ko.KnockoutObservable<string> = ko.observable(null);
    socialIconCssClasses: ko.KnockoutObservableArray<string> = ko.observableArray();

    newCommentActive: ko.KnockoutObservable<boolean> = ko.observable(false);
    newCommentWasActive: ko.KnockoutObservable<boolean> = ko.observable(false);

    newLinkUrl: ko.KnockoutObservable<string> = ko.observable(null)
    newImageUrl: ko.KnockoutObservable<string> = ko.observable(null)
    newFileAttachmentUrl: ko.KnockoutObservable<string> = ko.observable(null)

    scrollIntoView: ko.computed<void>;

    currentImageCallback: any = null;
    currentLinkCallback: any = null;
    currentFileAttachmentCallback: any = null;

    handleNewCommentClick: any;
    handleDeleteCommentClick: any;
    handleApproveCommentClick: any;
    handleReplyCommentClick: any;
    setCurrentReportTarget: any;
    handleReportCommentClick: any;

    newCommentEditor: any;
    newMetaCommentEditor: any;
    currentCommentEditor: any;

    handleEditCommentClick: any;
    handleCancelEditCommentClick: any;
    handleUpdateCommentClick: any;
    handlePinCommentClick: any;
    handleUnPinCommentClick: any;

    updateObservableManually: Function;

    recaptcha: any;

    currentRecaptchaSuccessFunction: any = null;
    dateHelper: any;
    urlHelper: any;

    allowReplies: any;
    isValid: any;

    constructor(el: HTMLDivElement,
        private summernoteFactory: TalkAboutSummernoteFactory) {
        var self = this

        self.threadElement = el;
        self.threadElementId = el.id;
        self.projectId = el.dataset.talkaboutProjectId;
        self.threadId = el.dataset.talkaboutThreadId;
        self.threadUrl = el.dataset.talkaboutThreadUrl;
        self.threadTitle = el.dataset.talkaboutThreadTitle;
        self.threadPubDate = el.dataset.talkaboutThreadPubDate;
        self.dataUrl = el.dataset.talkaboutDataUrl;
        
        // Read initial comment count from data attribute (defaults to 10 if not specified)
        const initialCountFromAttr = parseInt(el.dataset.talkaboutInitialCommentCount || '10');
        if (initialCountFromAttr > 0) {
            self.initialCommentCount(initialCountFromAttr);
            self.visibleCommentCount(initialCountFromAttr);
        }
        
        let reasonsSource: any = null;
        const script = document.querySelector('script[data-talkabout="report-reasons"]');
        if (script) {
            const json = script.textContent;
            if (json) {
                reasonsSource = JSON.parse(json);
            }
        }
        if (reasonsSource && Array.isArray(reasonsSource)) {
            const normalized = reasonsSource.map((r: any) => {
                if (typeof r === "string") {
                    return { label: r, value: r };
                }
                if (r && typeof r === "object" && r.label && r.value) {
                    return r;
                }
                return null;
            }).filter(x => x !== null);
            self.reportReasons(normalized);
        }

        self.dateHelper = new DateHelper(el.dataset.talkaboutLocale);
        self.urlHelper = new UrlHelper();

        self.initializeXsrfToken();
        self.getThread();


        self.scrollIntoView = ko.computed(() => {
            setTimeout(() => {
                const fragment = window.location.hash.substring(1);
                if (fragment) {
                    console.log(`scrolling to ${fragment}`);
                    const element = document.getElementById(fragment);
                    if (element) {
                        element.scrollIntoView();
                        element.classList.add('alert-info');
                    }
                }
            }, 200);
        });

        self.allowReplies = ko.computed(function () {
            if (self.allowPost() === false) { return false; }
            //not allowing anonymous replies
            // we don't have name and email inputs for replies
            if (self.isAuthenticated() === false) { return false; }

            return true;
        })

        self.isValid = ko.computed(function () {

            if (self.requireEmail() === true) {
                if (self.userEmail.hasError() === true) return false;
            }

            if (self.requireName() === true) {
                if (self.userName.hasError() === true) return false;
            }

            if (self.newCommentHtml() === null || self.newCommentHtml().length === 0) return false;
            //console.log('returning true for isvalid');
            return true;
        })

        // Initialize Load More Comments functionality
        self.visibleComments = ko.computed(function () {
            return self.comments().slice(0, self.visibleCommentCount());
        });

        self.hasMoreComments = ko.computed(function () {
            return self.comments().length > self.visibleCommentCount();
        });

        self.handleLoadMoreComments = function () {
            self.visibleCommentCount(self.visibleCommentCount() + self.initialCommentCount());
        };

        self.handleNewCommentClick = function () {
            const txtComment = document.getElementById('wmd-input-' + self.threadElementId + "-new-comment") as HTMLInputElement;
            const txtEmail = document.getElementById(self.threadElementId + "-commentemail") as HTMLInputElement;
            const txtUserName = document.getElementById(self.threadElementId + "-commentname") as HTMLInputElement;
            const txtUserUrl = document.getElementById(self.threadElementId + "-commenturl") as HTMLInputElement;

            const formData = new FormData();
            formData.append("ProjectId", self.projectId);
            formData.append("ThreadId", self.threadId);
            formData.append("ThreadUrl", self.threadUrl);
            formData.append("ThreadTitle", self.threadTitle);
            formData.append("UserName", txtUserName.value);
            formData.append("UserEmail", txtEmail.value);
            if (txtUserUrl) {
                formData.append("UserUrl", txtUserUrl.value);
            }
            formData.append("CommentHtml", txtComment.value);

            const makePostInvoker = function (formData, talker) {
                const invoker = {
                    invoke: function (recaptchaToken = null) {
                        if (recaptchaToken) {
                            formData.append("RecaptchaToken", recaptchaToken);
                        }

                        talker.fetchText("POST", talker.dataUrl + "/submitcomment", formData)
                            .then(function (text: string) {
                                const json = JSON.parse(text);
                                talker.handlePostCommentResponse(json);

                            }, function (err) {
                                alert('Oops, something went wrong');
                            }
                            );
                    }
                }
                return invoker;
            };

            const postInvoker = makePostInvoker(formData, self);

            if (self.requireCaptcha() === true) {
                if (!self.recaptcha) {
                    console.warn('reCAPTCHA required but not yet initialized');
                    alert('Awaiting reCAPTCHA initialization - please try again in a moment');
                    return;
                }

                if (self.useInvisibleCaptcha() === true) {
                    // Invisible reCAPTCHA - execute programmatically
                    self.currentRecaptchaSuccessFunction = postInvoker;
                    self.recaptcha.execute();
                } else {
                    // Visible reCAPTCHA - get token from form field
                    const recaptchaElement = document.querySelector('#divRecaptcha [name="g-recaptcha-response"]') as HTMLInputElement;
                    const recaptchaResponse = recaptchaElement ? recaptchaElement.value : null;
                    if (recaptchaResponse) {
                        postInvoker.invoke(recaptchaResponse);
                    } else {
                        return;
                    }
                }
            } else {
                postInvoker.invoke();
            }
        }

        self.handleApproveCommentClick = function (comment: Comment) {
            //console.log("approve");
            //console.log(comment);

            const formData = new FormData();
            formData.append("ProjectId", self.projectId);
            formData.append("ThreadId", self.threadId);
            formData.append("CommentId", comment.id);

            self.fetchText("POST", self.dataUrl + "/approvecomment", formData)
                .then(function (text: string) {
                    const json = JSON.parse(text);
                    self.handleApproveCommentResponse(json);

                }, function (err) {
                    alert('Oops, something went wrong');
                }
                );
        }

        self.handleEditCommentClick = function (comment: Comment) {
            if (self.canEditComment(comment) !== true) { return; }
            console.log("edit");
            comment.isActive(true);
            self.showCommentEditControls(comment.id);
            self.currentCommentEditor = self.getOrCreateEditor("-" + comment.id + "-edit-comment");
            console.log(comment);
        }

        self.handlePinCommentClick = function (comment: Comment) {
            comment.pinned(true);
            self.updatePinned(comment);
            self.comments.sort(self.commentsSorter);
        }

        self.handleUnPinCommentClick = function (comment: Comment) {
            comment.pinned(false);
            self.updatePinned(comment);
            self.comments.sort(self.commentsSorter);
        }


        self.handleUpdateCommentClick = function (comment: Comment) {
            //console.log("update comment");

            // manual intervention to capture attachment links put into MD editor from its buttons
            // which fail to trigger ko observable updates - JK
            //self.updateObservableManually(comment.html, `-${comment.id}-edit-comment`);

            comment.messageHtml(comment.html());
            comment.lastModUtc(new Date().toISOString());
            const formData = new FormData();
            formData.append("ProjectId", self.projectId);
            formData.append("ThreadId", self.threadId);
            formData.append("ThreadUrl", self.threadUrl);
            formData.append("ThreadTitle", self.threadTitle);
            formData.append("Id", comment.id);
            formData.append("CommentHtml", comment.html());

            console.log(comment.html());

            const makePostInvoker = function (formData, talker) {
                const invoker = {
                    invoke: function (recaptchaToken = null) {
                        if (recaptchaToken) {
                            formData.append("RecaptchaToken", recaptchaToken);
                        }

                        talker.fetchText("POST", talker.dataUrl + "/editcomment", formData)
                            .then(function (text: string) {
                                const json = JSON.parse(text);
                                talker.handleEditCommentResponse(json);
                            }, function (err) {
                                if (err && err.status === 403) {
                                    talker.hideCommentEditControls(comment.id);
                                    talker.showCommentStatusMessage(comment.id, 'Your changes cannot be saved at this time. Please refresh to see the latest.', true);
                                } else if (err && err.status === 404) {
                                    talker.hideCommentEditControls(comment.id);
                                    talker.showCommentStatusMessage(comment.id, 'We could not find that comment. Please refresh to see the latest.', true);
                                } else {
                                    talker.showCommentStatusMessage(comment.id, 'Your changes cannot be saved at this time.', true);
                                }
                            }
                            );
                    }
                }
                return invoker;
            };

            const postInvoker = makePostInvoker(formData, self);

            if (self.requireCaptcha() === true && self.recaptcha) {
                self.currentRecaptchaSuccessFunction = postInvoker;
                self.recaptcha.execute();
            } else {
                postInvoker.invoke();
            }

        }

        self.handleCancelEditCommentClick = function (comment: Comment) {
            comment.isActive(false);
            self.hideCommentEditControls(comment.id);
            self.currentCommentEditor = null;


            console.log(comment);
        }

        self.handleDeleteCommentClick = function (comment: Comment) {
            if (self.canDeleteComment(comment) !== true) {
                self.showCommentStatusMessage(comment.id, 'This comment has been moderated and approved; you cannot delete it. Please refresh to see the latest.', true);
                return;
            }
            //console.log("delete");
            //console.log(comment);
            const formData = new FormData();
            formData.append("ProjectId", self.projectId);
            formData.append("ThreadId", self.threadId);
            formData.append("CommentId", comment.id);

            self.fetchText("POST", self.dataUrl + "/deletecomment", formData)
                .then(function (text: string) {
                    const json = JSON.parse(text);
                    self.handleDeleteCommentResponse(json);

                }, function (err) {
                    if (err && err.status === 403) {
                        self.showCommentStatusMessage(comment.id, 'This comment has been moderated and approved; you cannot delete it. Please refresh to see the latest.', true);
                    } else if (err && err.status === 404) {
                        self.showCommentStatusMessage(comment.id, 'We could not find that comment. Please refresh to see the latest.', true);
                    } else {
                        self.showCommentStatusMessage(comment.id, 'Your changes cannot be saved at this time.', true);
                    }
                }
                );
        }

        self.setCurrentReportTarget = function (comment: Comment) {
            self.currentReportCommentId(comment.id);
        }

        self.handleReportCommentClick = function (comment: any = null) {
            // basic validation: reason required, details length <= 1000
            const targetCommentId = typeof comment === "string" ? comment : (comment ? comment.id : self.currentReportCommentId());

            if (!targetCommentId) {
                return;
            }

            if (!self.reportReason()) {
                self.showCommentStatusMessage(targetCommentId, 'Please select a reason to report this comment.', false);
                return;
            }

            const details = self.reportText();
            if (details && details.length > 1000) {
                self.showCommentStatusMessage(targetCommentId, 'Details must be 1000 characters or fewer.', false);
                return;
            }

            // prevent duplicate from client-side if already reported by current user
            if (self.reportedByCurrentUser().indexOf(targetCommentId) > -1) {
                self.showCommentStatusMessage(targetCommentId, 'Already reported.', false);
                return;
            }

            // prevent reporting own comment
            const targetComment = self.comments().find(c => c.id === targetCommentId);
            if (self.userId() && targetComment && targetComment.userId && self.userId() === targetComment.userId) {
                self.showCommentStatusMessage(targetCommentId, 'You cannot report your own comment.', false);
                return;
            }
            if (targetComment && targetComment.reportedByCurrentUser && targetComment.reportedByCurrentUser() === true) {
                self.showCommentStatusMessage(targetCommentId, 'Already reported.', false);
                return;
            }

            const formData = new FormData();
            formData.append("ProjectId", self.projectId);
            formData.append("ThreadId", self.threadId);
            formData.append("CommentId", targetCommentId);
            formData.append("ReportReason", self.reportReason());
            if (details) {
                formData.append("ReportText", details);
            }
            if (self.reportSendEmailCopy()) {
                formData.append("EmailCopyRequested", "true");
            }

            self.fetchText("POST", self.dataUrl + "/reportcomment", formData)
                .then(function (text: string) {
                    const json = JSON.parse(text);
                    if (json.alreadyReported) {
                        self.showCommentStatusMessage(targetCommentId, 'Already reported.', false);
                        if (self.reportedByCurrentUser().indexOf(targetCommentId) === -1) {
                            self.reportedByCurrentUser.push(targetCommentId);
                        }
                        if (targetComment) {
                            targetComment.reportedByCurrentUser(true);
                        }
                        const modal = document.getElementById('md-report-comment');
                        if (modal) {
                            const bsModal = (window as any).bootstrap ? (window as any).bootstrap.Modal.getInstance(modal) : null;
                            if (bsModal) {
                                bsModal.hide();
                            } else {
                                (window as any).$ ? (window as any).$(modal).modal('hide') : null;
                            }
                        }
                        return;
                    }

                    self.showCommentStatusMessage(targetCommentId, 'Report received. Our team will review.', false);
                    if (self.reportedByCurrentUser().indexOf(targetCommentId) === -1) {
                        self.reportedByCurrentUser.push(targetCommentId);
                    }
                    if (targetComment) {
                        targetComment.reportedByCurrentUser(true);
                        targetComment.reported(true);
                    }
                    self.reportReason(null);
                    self.reportText(null);
                    self.reportSendEmailCopy(false);
                    self.currentReportCommentId(null);
                    // close modal if present
                    const modal = document.getElementById('md-report-comment');
                    if (modal) {
                        // Bootstrap 5
                        const bsModal = (window as any).bootstrap ? (window as any).bootstrap.Modal.getInstance(modal) : null;
                        if (bsModal) {
                            bsModal.hide();
                        } else {
                            // Bootstrap 4 fallback
                            (window as any).$ ? (window as any).$(modal).modal('hide') : null;
                        }
                    }
                }, function (err) {
                    if (err && err.status === 409) {
                        self.showCommentStatusMessage(targetCommentId, 'Already reported.', false);
                        if (self.reportedByCurrentUser().indexOf(targetCommentId) === -1) {
                            self.reportedByCurrentUser.push(targetCommentId);
                        }
                        if (targetComment) {
                            targetComment.reportedByCurrentUser(true);
                        }
                        const modal = document.getElementById('md-report-comment');
                        if (modal) {
                            const bsModal = (window as any).bootstrap ? (window as any).bootstrap.Modal.getInstance(modal) : null;
                            if (bsModal) {
                                bsModal.hide();
                            } else {
                                (window as any).$ ? (window as any).$(modal).modal('hide') : null;
                            }
                        }
                    } else if (err && err.status === 403) {
                        self.showCommentStatusMessage(targetCommentId, 'You must be signed in to report comments.', false);
                    } else {
                        self.showCommentStatusMessage(targetCommentId, 'Could not submit your report. Please try again.', true);
                    }
                });
        }

        self.handleReplyCommentClick = function (comment: Comment) {
            //console.log("reply");
            //console.log(comment);

            const formData = new FormData();
            formData.append("ProjectId", self.projectId);
            formData.append("ThreadId", self.threadId);
            formData.append("ThreadTitle", self.threadTitle);
            formData.append("ThreadUrl", self.threadUrl);
            formData.append("UserName", self.userName());
            formData.append("UserEmail", self.userEmail());
            formData.append("UserUrl", self.userWebsite());
            formData.append("Parentid", comment.id);

            const input = document.getElementById("wmd-input-" + comment.id + "-new-comment") as HTMLTextAreaElement;
            if (input) {
                formData.append("CommentHtml", input.value);
            } else {
                console.log('no input');
                formData.append("CommentHtml", comment.newReply());
            }

            const makePostInvoker = function (formData, talker, comment) {
                const invoker = {
                    invoke: function (recaptchaToken = null) {
                        if (recaptchaToken) {
                            formData.append("RecaptchaToken", recaptchaToken);
                        }

                        talker.fetchText("POST", talker.dataUrl + "/submitcomment", formData)
                            .then(function (text: string) {
                                const json = JSON.parse(text);

                                const c = new Comment();
                                talker.loadCommentFromJson(c, json.comment);
                                c.depth = comment.depth + 1;

                                //allow edit since the current user is the author of the new comment even if unauthenticated
                                c.tempAllowEdit(true);
                                c.showUnapproved(true);

                                comment.replies.push(c);

                                const newCommentInput = document.getElementById("wmd-input-" + c.id + "-new-comment");
                                if (newCommentInput) {
                                    c.replyEditor = talker.getOrCreateEditor("-" + c.id + "-new-comment")
                                }

                                comment.newReply('');

                                const toggle = document.getElementById("btn-reply-" + comment.id);
                                if (toggle) {
                                    toggle.click();
                                }

                            }, function (err) {
                                alert('Oops, something went wrong');
                            }
                            );
                    }
                }
                return invoker;
            };

            const postInvoker = makePostInvoker(formData, self, comment);

            if (self.requireCaptcha() === true) {
                if (!self.recaptcha) {
                    console.warn('reCAPTCHA required but not yet initialized');
                    alert('Awaiting reCAPTCHA initialization - please try again in a moment');
                    return;
                }

                if (self.useInvisibleCaptcha() === true) {
                    // Invisible reCAPTCHA - execute programmatically
                    self.currentRecaptchaSuccessFunction = postInvoker;
                    self.recaptcha.execute();
                } else {
                    // Visible reCAPTCHA - get token from form field
                    const recaptchaElement = document.querySelector('#divRecaptcha [name="g-recaptcha-response"]') as HTMLInputElement;
                    const recaptchaResponse = recaptchaElement ? recaptchaElement.value : null;
                    if (recaptchaResponse) {
                        postInvoker.invoke(recaptchaResponse);
                    } else {
                        return;
                    }
                }
            } else {
                postInvoker.invoke();
            }
        }


        windowHelper.setWindowFunction("DropZoneSuccessHandler", function (file, serverResponse, editor) {
            // console.log('handle image drop');       

            const whichDropzone = editor.dropZone.element.id;
            if (whichDropzone) {
                if (whichDropzone === "dzAttachment") {
                    self.doFileAttachmentInsert();
                    modalManager.closeFileAttachmentModal();
                }
                else if (whichDropzone === "dz1") {
                    self.doImageInsert();
                    modalManager.closeImageModal();
                }
            }
        });

        windowHelper.setWindowFunction("ServerFileSelected", function () {
            console.log('handle server file selected');

            self.doImageInsert();
            modalManager.closeImageModal();
        });

        // Old callback-based initialization - no longer used
        // We now initialize reCAPTCHA manually after thread data loads using grecaptcha.ready() (see loadThread method)
        // captchaHelper.setupCaptcha = function (g) {
        //     self.setupRecaptcha(g);
        // }
    }

    updatePinned(comment: Comment) {
        let self = this;

        const formData = new FormData();
        formData.append("ProjectId", self.projectId);
        formData.append("ThreadId", self.threadId);
        formData.append("CommentId", comment.id);
        formData.append("Pinned", comment.pinned());

        self.fetchText("POST", self.dataUrl + "/PinComment", formData)
            .then(function (text: string) {
                const json = JSON.parse(text);
                self.handleApproveCommentResponse(json);

            }, function (err) {
                alert('Oops, something went wrong');
            }
            );
    }

    commentsSorter(a: Comment, b: Comment) {
        if (a.pinned() !== b.pinned()) {
            return a.pinned() ? -1 : 1;
        } else {
            return (new Date(b.createdUtc) as any) < (new Date(a.createdUtc) as any) ? -1 : 1;
        }
    }

    showCommentEditControls(commentId: string) {
        const btnDelete = document.getElementById('btn-delete-' + commentId);
        const btnReport = document.getElementById('btn-report-' + commentId);
        const btnReply  = document.getElementById('btn-reply-' + commentId);
        const btnEdit   = document.getElementById('btn-edit-' + commentId);
        const btnSave   = document.getElementById('btn-save-' + commentId);
        const btnCancel = document.getElementById('btn-cancel-edit-' + commentId);

        btnDelete.classList.add('collapse');
        if (btnReport) {
            btnReport.classList.add('collapse');
        }
        btnSave.classList.remove('collapse');
        btnEdit.classList.add('collapse');
        btnReply.classList.add('collapse');
        btnCancel.classList.remove('collapse');

        const html = document.getElementById('comment-html-' + commentId);
        if (html) {
            html.style.display = 'none';
            console.log('hid html');
            console.log(html);
        }

        document.getElementById('comment-edit-' + commentId).style.display = 'block';
        console.log('showCommentEditControls');
    }

    hideCommentEditControls(commentId: string) {
        const btnDelete = document.getElementById('btn-delete-' + commentId);
        const btnReport = document.getElementById('btn-report-' + commentId);
        const btnReply  = document.getElementById('btn-reply-' + commentId);
        const btnEdit   = document.getElementById('btn-edit-' + commentId);
        const btnSave   = document.getElementById('btn-save-' + commentId);
        const btnCancel = document.getElementById('btn-cancel-edit-' + commentId);

        btnDelete.classList.remove('collapse');
        if (btnReport) {
            btnReport.classList.remove('collapse');
        }
        btnSave.classList.add('collapse');
        btnEdit.classList.remove('collapse');
        btnReply.classList.remove('collapse');
        btnCancel.classList.add('collapse');
        document.getElementById('comment-html-' + commentId).style.display = 'block';
        document.getElementById('comment-edit-' + commentId).style.display = 'none';
        console.log('hideCommentEditControls');
    }

    showStatusMessage(message: string, offerRefresh: boolean = false) {
        let container = this.threadElement.querySelector('.talkabout-status-message') as HTMLElement;
        if (!container) {
            container = document.createElement('div');
            container.className = 'alert alert-warning alert-dismissible fade show talkabout-status-message mt-2';
            container.setAttribute('role', 'alert');
            this.threadElement.prepend(container);
        } else {
            container.innerHTML = '';
        }

        const msg = document.createElement('span');
        msg.textContent = message;
        container.appendChild(msg);

        if (offerRefresh) {
            const refreshButton = document.createElement('button');
            refreshButton.type = 'button';
            refreshButton.className = 'btn btn-sm btn-outline-secondary ms-2 align-middle';
            refreshButton.textContent = 'Refresh';
            (refreshButton.style as any).verticalAlign = 'middle';
            refreshButton.onclick = () => { window.location.reload(); };
            container.appendChild(refreshButton);
        }

        const closeButton = document.createElement('button');
        closeButton.type = 'button';
        closeButton.className = 'btn-close';
        closeButton.setAttribute('aria-label', 'Close');
        closeButton.onclick = () => container.remove();
        container.appendChild(closeButton);
    }

    showCommentStatusMessage(commentId: string, message: string, offerRefresh: boolean = false) {
        const cardBody = document.querySelector(`#comment-${commentId}`)?.closest('.card')?.querySelector('.card-body') as HTMLElement;
        if (!cardBody) {
            this.showStatusMessage(message, offerRefresh);
            return;
        }

        let container = cardBody.querySelector('.talkabout-status-message') as HTMLElement;
        if (!container) {
            container = document.createElement('div');
            container.className = 'alert alert-warning alert-dismissible fade show talkabout-status-message mb-2';
            container.setAttribute('role', 'alert');
            cardBody.prepend(container);
        } else {
            container.innerHTML = '';
        }

        const msg = document.createElement('span');
        msg.textContent = message;
        container.appendChild(msg);

        if (offerRefresh) {
            const refreshButton = document.createElement('button');
            refreshButton.type = 'button';
            refreshButton.className = 'btn btn-sm btn-outline-secondary ms-2 align-middle';
            refreshButton.textContent = 'Refresh';
            (refreshButton.style as any).verticalAlign = 'middle';
            refreshButton.onclick = () => { window.location.reload(); };
            container.appendChild(refreshButton);
        }

        const closeButton = document.createElement('button');
        closeButton.type = 'button';
        closeButton.className = 'btn-close';
        closeButton.setAttribute('aria-label', 'Close');
        closeButton.onclick = () => container.remove();
        container.appendChild(closeButton);
    }

    getOrCreateEditor(elementIdSuffix: string) {
        return this.summernoteFactory.getEditor(`wmd-input${elementIdSuffix}`);
    }

    setupRecaptcha(g) {
        let self = this;
        if (self.allowPost() === true && self.requireCaptcha() === true) {

            self.recaptcha = g;
            if (self.recaptcha) {
                var renderDiv = document.getElementById("divRecaptcha");
                if (renderDiv) {
                    var publicKey = self.recaptchaPublicKey();

                    // Fail gracefully if reCAPTCHA key is not configured
                    if (!publicKey || publicKey.trim() === '') {
                        console.warn('reCAPTCHA is required but no public key is configured. Disabling reCAPTCHA requirement.');
                        self.requireCaptcha(false);
                        self.recaptcha = null;
                        return;
                    }

                    if (self.useInvisibleCaptcha() === true) {
                        // Invisible reCAPTCHA - programmatic rendering with callback
                        var callback = self.buildRecaptchaCallback();
                        self.recaptcha.render(
                            renderDiv,
                            {
                                'sitekey': publicKey,
                                'callback': callback,
                                'size': 'invisible'
                            }
                        );
                    } else {
                        // Visible reCAPTCHA - programmatic rendering without callback
                        self.recaptcha.widgetId = self.recaptcha.render(
                            renderDiv,
                            {
                                'sitekey': publicKey
                            }
                        );
                    }
                }
            }
        }
    }

    buildRecaptchaCallback() {
        let self = this;
        let callback = function (token: any) {
            return new Promise<void>(function (resolve, reject) {
                console.log('recaptcha token ' + token);
                if (self.currentRecaptchaSuccessFunction !== null) {
                    self.currentRecaptchaSuccessFunction.invoke(token);
                    self.currentRecaptchaSuccessFunction = null;
                }
                resolve();
                if (self.recaptcha) {
                    self.recaptcha.reset();
                }
            });
        }
        return callback;
    }

    handleImageDropSuccess(file, serverResponse) {
        let self = this;
        //console.log('handle image drop');
        self.doImageInsert();
        modalManager.closeImageModal();
    }

    doFileAttachmentInsert() {
        let self = this;

        // console.log("newFileAttachmentUrl is " + self.newFileAttachmentUrl());

        if (self.newFileAttachmentUrl() === null) {
            var hidden = document.getElementById("attachmentUrlIntegration") as HTMLInputElement;
            if (hidden) {
                // console.log(hidden.value);
                self.newFileAttachmentUrl(hidden.value);
            }
        }

        var url = self.newFileAttachmentUrl();
        // console.log("doFileAttachmentInsert " + url);
        if (url && url.length > 8 && (url.startsWith("https://") || url.startsWith("/"))) {
            if (self.currentFileAttachmentCallback) {
                // console.log('invoking attachment call back with ' + url);
                self.currentFileAttachmentCallback(url);
                self.newFileAttachmentUrl(null);
            }
        }
    }

    doImageInsert() {
        let self = this;

        if (self.newImageUrl() === null) {
            var hidden = document.getElementById("imgUrlIntegration") as HTMLInputElement;
            if (hidden) {
                self.newImageUrl(hidden.value);
            }
        }

        var url = self.newImageUrl();
        if (url && url.length > 8 && (url.startsWith("https://") || url.startsWith("/"))) {
            if (self.currentImageCallback) {
                // console.log('invoking call back with ' + url);
                self.currentImageCallback(url);
                self.newImageUrl(null);
                let dz = document.getElementById('dzImage') as HTMLImageElement;
                if (dz) {
                    dz.src = "/cr/images/690x517-placeholder.png";
                }
            }
        }

    }

    getComment(id: string): Comment {
        let self = this;

        for (var i = 0; i < self.comments().length; i++) {
            var c = self.comments()[i];
            if (c.id === id) { return c; }
        }

        return null;
    }

    isValidReply(comment: Comment) {
        let self = this;

        //if (self.userEmail.hasError() === true) return false;
        //if (self.userName.hasError() === true) return false;

        if (comment.newReply() === null || comment.newReply().length === 0) return false;

        return true;
    }

    canEditComment(comment: Comment) {
        let self = this;

        if (comment.isLocked() === true) { return false; }

        //this is set true for brand new posts
        if (comment.tempAllowEdit() === true) { return true; }

        if (self.isModerator()) { return true; }

        const isAnonymousAuthor = !comment.userId;
        const requiresModeration = isAnonymousAuthor ? self.moderateAnonymousPosts() : self.moderateAuthenticatedPosts();
        if (comment.approvedUtc() !== null && requiresModeration === true) {
            return false;
        }

        if (self.userId()) {
            if (comment.userId === self.userId()) {
                return true;
            }
        }



        return false;
    }
    canDeleteComment(comment: Comment) {
        let self = this;

        if (comment.isLocked() === true) { return false; }

        if (comment.tempAllowEdit() === true) { return true; }

        if (self.isModerator()) { return true; }

        const isAnonymousAuthor = !comment.userId;
        const requiresModeration = isAnonymousAuthor ? self.moderateAnonymousPosts() : self.moderateAuthenticatedPosts();
        if (comment.approvedUtc() !== null && requiresModeration === true && self.allowDeleteModeratedPosts() === false) {
            return false;
        }

        if (self.userId()) {
            if (comment.userId === self.userId()) {
                return true;
            }
        }

        return false;
    }

    showComment(comment: Comment) {
        let self = this;
        if (self.isModerator() === true) return true;
        if (comment.showUnapproved() === true) return true;// so unauthenticated user can see his own comment

        const userId = self.userId();
        if (userId && userId === comment.userId) return true;

        //console.log('show comment');

        let show = comment.approvedUtc() !== null && comment.approvedUtc().length > 0;
        //console.log(show);
        return show;
    }

    handleApproveCommentResponse(json: any) {
        let self = this;
        if (json.comment) {
            var c = self.getComment(json.comment.id);
            if (c) {
                c.approvedUtc(json.comment.approvedUtc);
            }
        }
    }

    handleDeleteCommentResponse(json: any) {
        let self = this;
        if (json.error) {
            if (json.error === "forbidden" && json.commentId) {
                self.showCommentStatusMessage(json.commentId, 'This comment has been moderated and approved; you cannot delete it. Please refresh to see the latest.', true);
            }
            return;
        }
        if (json.commentId) {

            self.comments().forEach(function (item: Comment, index) {
                item.deleteReply(json.commentId);
            });

            self.comments.remove(function (item: Comment) {
                return item.id == json.commentId;
            });
        }
        // the modal doesn't completely go away after click delete
        //body has class modal-open style=padding-right:17px
        var modals = document.getElementsByClassName("modal-backdrop");
        //Array.from(modals).forEach((el) => {
        //    //console.log(el.tagName);
        //    el.remove();
        //    document.body.classList.remove("modal-open");
        //    document.body.removeAttribute("style");

        //});
        Array.from(modals).forEach(function (el) {
            //console.log(el.tagName);
            el.remove();
            document.body.classList.remove("modal-open");
            document.body.removeAttribute("style");

        });

    }

    handlePostCommentResponse(json: any) {
        var self = this;

        //console.log(json);

        if (json.comment) {
            var c = new Comment();
            self.loadCommentFromJson(c, json.comment);
            c.showUnapproved(true);

            //allow edit since the current user is the author of the new comment even if unauthenticated
            c.tempAllowEdit(true);

            self.comments.push(c);

            var newCommentInput = document.getElementById("wmd-input-" + c.id + "-new-comment");
            if (newCommentInput) {
                c.replyEditor = self.getOrCreateEditor("-" + c.id + "-new-comment")
            }
            self.newCommentHtml('');

            self.comments.sort(self.commentsSorter);
        }
        else if (json.errorMessage) {
            //TODO: show message
        }

    }

    handleEditCommentResponse(json: any) {
        var self = this;
        if (json.comment) {
            self.hideCommentEditControls(json.comment.id);
        } else {
            //TODO: show message
            alert('something went wrong');
        }
    }


    getThread() {
        var self = this;

        if (self.dataUrl) {
            var formData = new FormData();
            formData.append("ProjectId", self.projectId);
            formData.append("ThreadId", self.threadId);
            formData.append("ThreadUrl", self.threadUrl);
            if (self.threadPubDate) {
                formData.append("ThreadPubDate", self.threadPubDate);
            }

            self.fetchText("POST", self.dataUrl + "/data", formData)
                .then(function (text: string) {
                    //console.log(text);
                    var json = JSON.parse(text);
                    self.loadThread(json);
                    //console.log('thread loaded');

                }, function (err) {
                    alert('Oops, something went wrong');
                }
                );


        }
        else {
            console.log('no data url provided');
        }

    }

    loadCommentFromJson(comment: Comment, json: any) {
        let self = this;

        comment.id = json.id;
        if (json.approvedUtc) {
            comment.approvedUtc(json.approvedUtc);
        }

        comment.createdUtc = json.createdUtc;
        comment.dateDescription = self.dateHelper.getDistanceInWordsToNow(comment.createdUtc);
        comment.messageHtml(json.html);
        //comment.markdown(json.markdown);
        comment.html(json.html);
        comment.threadId = json.threadId;
        comment.userAvatarUrl = json.userAvatarUrl ?? "https://www.gravatar.com/avatar/205e460b479e2e5b48aec07710c08d50?f=y&s=80&d=mp";
        comment.userId = json.userId;
        comment.userName = json.userName;
        comment.userWebsite = json.userWebsite;
        comment.allowReplies(json.allowReplies);
        comment.isLocked(json.isLocked);
        comment.lastModUtc(json.lastModUtc);
        comment.pinned(json.pinned);
        // comment.dateModDescription = self.dateHelper.getDistanceInWordsToNow(comment.lastModUtc());

        comment.dateModDescription = ko.computed(() => {
            let self = this;
            return self.dateHelper.getDistanceInWordsToNow(comment.lastModUtc());
        })


        if (json.approvedUtc) {
            comment.approvedUtc(json.approvedUtc)
        }

        if (json.hasOwnProperty('isAnswer')) {
            comment.isAnswer(json.isAnswer);
        }

        if (json.hasOwnProperty('parentId')) {
            comment.parentId(json.parentId);
        }

        if (json.hasOwnProperty('isMetaComment')) {
            comment.isMetaComment(json.isMetaComment);
        }

        if (json.hasOwnProperty('votes')) {
            comment.votes(json.votes);
        }
        if (json.hasOwnProperty('reported')) {
            comment.reported(json.reported === true);
        }
        if (json.hasOwnProperty('reportedCount')) {
            comment.reportedCount(json.reportedCount);
        }
        if (json.hasOwnProperty('reportedByCurrentUser')) {
            comment.reportedByCurrentUser(json.reportedByCurrentUser === true);
            if (json.reportedByCurrentUser === true && self.reportedByCurrentUser().indexOf(comment.id) === -1) {
                self.reportedByCurrentUser.push(comment.id);
            }
        }

        //comment.commentHasBeenEdited = function () {
        //    const timeDiff = new Date(comment.lastModUtc()).valueOf() - new Date(comment.createdUtc).valueOf();
        //    return timeDiff > 1000;  
        //};
    }

    _loadReplies(comment: Comment, json: any) {
        let self = this;

        if (json.replies && json.replies.length > 0) {

            for (let i = 0; i < json.replies.length; i++) {
                var r = json.replies[i];
                //console.log('found reply');
                //console.log(r);

                var reply = new Comment();
                self.loadCommentFromJson(reply, r);
                reply.depth = comment.depth + 1;
                comment.replies.push(reply);

                if (reply.depth < 3) {
                    self._loadReplies(reply, r);
                }

            }
        }

    }

    loadThread(json) {
        console.log(json);
        let self = this;

        self.allowPost(json.allowPost);
        self.allowWebsiteUrl(json.allowWebsiteUrl);
        self.currentPage(json.comments.pageNumber);
        self.pageSize(json.comments.pageSize);
        self.totalItems(json.comments.totalItems);
        self.isModerator(json.isModerator);
        self.requireCaptcha(json.requireCaptcha);
        self.recaptchaPublicKey(json.recaptchaPublicKey);
        self.useInvisibleCaptcha(json.useInvisibleCaptcha);
        self.requireEmail(json.requireEmail);
        self.requireName(json.requireName);
        self.maxDepth(json.maxDepth);
        self.moderateAnonymousPosts(json.moderateAnonymousPosts);
        self.moderateAuthenticatedPosts(json.moderateAuthenticatedPosts);
        self.allowDeleteModeratedPosts(json.allowDeleteModeratedPosts);

        if (json.uploadSettings) {
            self.allowImageUpload(json.uploadSettings.canUpload);
            self.imageUploadUrl(json.uploadSettings.uploadUrl);
        }

        if (json.loginSettings) {
            self.loginUrl(json.loginSettings.loginUrl);
            if (json.loginSettings.socialProviderCssClassesCsv) {
                let arr = json.loginSettings.socialProviderCssClassesCsv.split(',');
                for (var i = 0; i < arr.length; i++) {
                    self.socialIconCssClasses.push(arr[i]);
                }
            }
        }

        if (json.currentUser) {
            self.isAuthenticated(true);
            if (json.currentUser.userId) {
                self.userId(json.currentUser.userId);
            }
            if (json.currentUser.email) {
                self.userEmail(json.currentUser.email);
            }
            if (json.currentUser.userName) {
                self.userName(json.currentUser.userName);
            }

            if (json.currentUser.websiteUrl) {
                self.hasUserUrl(true);
                self.userWebsite(json.currentUser.websiteUrl);
            }

            if (json.currentUser.avatarUrl) {
                self.userAvatarUrl(json.currentUser.avatarUrl);
            }
        }
        if (json.comments.data && json.comments.data.length > 0) {

            //console.log('found comments');

            for (let i = 0; i < json.comments.data.length; i++) {
                //console.log(i);
                var c = json.comments.data[i];
                var comment = new Comment();
                self.loadCommentFromJson(comment, c);

                self.comments.push(comment);

                if (self.isAuthenticated() == true) {
                    var newCommentInput = document.getElementById("wmd-input-" + comment.id + "-new-comment");
                    if (newCommentInput) {
                        comment.replyEditor = self.getOrCreateEditor("-" + comment.id + "-new-comment")
                    }
                }

                self._loadReplies(comment, c);
            }

            //now sort them            
            self.comments.sort(self.commentsSorter);
            //console.log(self.comments());
        }

        //create new comment editor
        if (self.isAuthenticated() == true) {
            var newCommentInput = document.getElementById("wmd-input-" + self.threadId + "-new-comment");
            if (newCommentInput) {
                comment.replyEditor = self.getOrCreateEditor("-" + self.threadId + "-new-comment")
            }
        }

        // Initialize reCAPTCHA after thread configuration is loaded
        // This ensures we have the correct allowPost/requireCaptcha values before attempting to render
        // We use grecaptcha.ready() to wait for the API to be fully loaded (handles race conditions)
        if (window['grecaptcha'] && !self.recaptcha) {
            window['grecaptcha'].ready(function () {
                self.setupRecaptcha(window['grecaptcha']);
            });
        }

        var event = new CustomEvent('thread-json-loaded', { detail: json });
        self.threadElement.dispatchEvent(event);
    }

    getButtonPostText() {
        let self = this;

        let formatter = function (b, args) {
            var a = arguments;
            return b.replace(/(\{\{\d\}\}|\{\d\})/g, function (b) {
                if (b.substring(0, 2) == "{{") return b;
                var c = parseInt(b.match(/\d/)[0]);
                return a[c + 1]
            })
        };

        let format = "Post as {0}";

        if (self.isAuthenticated() === true) {
            return formatter(format, [self.userName()]);
        }
        else {
            return formatter(format, ['Guest']);
        }
    }

    initializeXsrfToken() {
        let self = this;
        let token = self.xsrfToken;
        let tokenName = self.xsrfTokenName
        if (!token || !tokenName) {
            self.fetchText("GET", self.dataUrl + "/token")
                .then(function (text: string) {
                    //console.log(text);
                    var json = JSON.parse(text);
                    self.xsrfToken = json.token;
                    self.xsrfTokenName = json.tokenName;

                }, function (err) {
                    //alert('Oops, something went wrong');
                }
                );
        }
    }



    fetchText(method: string, url: string, data: any = null, contentType: string = null) {
        let self = this;
        const sanitisedUrl = self.urlHelper.sanitiseUrl(url);

        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                var DONE = 4; // readyState 4 means the request is done.
                var OK = 200; // status 200 is a successful return.
                if (xhr.readyState === DONE) {
                    if (xhr.status === OK) {
                        resolve(xhr.responseText);
                    }
                    else {
                        reject({
                            status: xhr.status,
                            responseText: xhr.responseText
                        });
                    }
                }
            };
            xhr.open(method, sanitisedUrl);

            let token = self.xsrfToken;
            let tokenName = self.xsrfTokenName;
            if (token && tokenName) {
                xhr.setRequestHeader(tokenName, token);
            }

            if (contentType) {
                xhr.setRequestHeader('Content-Type', contentType);
            }
            xhr.responseType = "text";
            xhr.send(data);
        });
    }

}

